import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import LoadingAnimation from '../../../../components/LoadingAnimation.jsx';
import { postAsync } from '../../../../components/helper/axiosHelper';
import { login } from '../../../../features/authSlice.js';
import { menucontrol } from '../../../../features/togglebuttonSlice.js';
import { PageHitCountApi } from '../../../../shared/Helper.jsx';

const ManagementLogin = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [token, setToken] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);


  const { pathname } = useLocation();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
    localStorage.setItem('isAdmin', false);
  }, []);

  useEffect(() => {
    //localStorage.clear();
    localStorage.setItem('isHome', true);
    localStorage.removeItem('token');
    localStorage.removeItem('id');
    localStorage.removeItem('apid');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userName');
    localStorage.removeItem('name');
    localStorage.removeItem('role');
    localStorage.removeItem('email');
    localStorage.removeItem('statusCode');
    localStorage.removeItem('message');
    localStorage.removeItem('userId');
  }, []);

  const Login = (e) => {
    e.preventDefault();
    if (validate()) {
      setIsLoading(true);
      postAsync(
        'Authentication/Login',
        {
          username,
          password,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
        .then((response) => {
          if (response.statusCode === 0 || response.statusCode === 422) {
            setIsLoading(false);
            toast.warning(`${t('Login Failed! Username or Password is incorrect.')}`);
          } else {
            setStorage(response, setToken);
            dispatch(login(response));
            localStorage.setItem('isHome', false);
            dispatch(menucontrol(false));
            localStorage.setItem('isAdmin', true);
            //navigate('/admin');
            toast.success(`${t('msg_loginSuccess')}`);
            window.location.href = '/admin';
          }
        })
        .catch((error) => {
          setIsLoading(false);
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const validate = () => {
    let result = true;
    if (username === '' || username === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}` + `${t('username')}`);
    }
    if (password === '' || password === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}` + `${t('password')}`);
    }
    return result;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="1500" className="pt-12  xl:pt-28 items-center">
      <div
        className="py-10"
        style={ {
          background: `transparent url('./assets/Sharjah-stroke-logo-1.png') left top 0px no-repeat`,

          width: '100%',
        } }
      >
        { ' ' }
      </div>
      {/* <img src="./assets/Sharjah-stroke-logo-1.png" alt="" /> */ }
      { isLoading ? (
        <LoadingAnimation imageStyling={ '' } styling={ 'flex items-center py-5 align-middle justify-center space-x-2' } />
      ) : (
        <div className="container-fluid ">
          <div className="row justify-center items-center">
            <div className=" col-lg-4  col-sm-6">
              <form onSubmit={ Login } className="container max-w-screen-sm py-4">
                <div className="card rounded-4xl  shadow-customgreen bg-green-50">
                  <div className="card-body flex flex-col  gap-y-4">
                    <div className="row justify-center items-center">
                      <div className=" flex justify-center">
                        <div className="w-24 h-24  flex items-center justify-center rounded-full border-2 border-customgreen">
                          <svg
                            version="1.0"
                            xmlns="http://www.w3.org/2000/svg"
                            width="50.000000pt"
                            height="50.000000pt"
                            viewBox="0 0 290.000000 350.000000"
                            preserveAspectRatio="xMidYMid meet"
                          >
                            { ' ' }
                            <g
                              transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                              fill="#1d8b4b"
                              stroke="none"
                            >
                              { ' ' }
                              <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />{ ' ' }
                              <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />{ ' ' }
                            </g>{ ' ' }
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="row justify-center items-center">
                      <div className="col-lg-6 w-auto text-center">
                        <h2 className="text-xl text-customgreen font-semibold">{ t('login_mgmt') }</h2>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>
                        { t('username') }
                        <span className="errmsg">*</span>
                      </label>
                      <input
                        value={ username }
                        minLength="1"
                        maxLength="50"
                        onChange={ (e) => setUsername(e.target.value) }
                        className=" border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                        placeholder={ t('username') }
                        type="text"
                        name="username"
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        { t('password') }
                        <span className="errmsg">*</span>
                      </label>
                      <div style={ { position: 'relative', flex: 1 } }>
                        <input
                          value={ password }
                          minLength="1"
                          maxLength="50"
                          onChange={ (e) => setPassword(e.target.value) }
                          className=" border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                          placeholder={ t('password') }
                          type={ showPassword ? 'text' : 'password' }
                          name="password"
                        />
                        <button
                          type="button"
                          className={ `eye-button ${isActive ? 'left-1' : 'right-1'}` }
                          style={ {
                            backgroundColor: 'transparent',
                            border: '0',
                            position: 'absolute',

                            top: '50%',
                            transform: 'translateY(-50%)',
                          } }
                          onClick={ togglePasswordVisibility }
                        >
                          { showPassword ? <VisibilityIcon /> : <VisibilityOffIcon /> }
                        </button>
                      </div>
                    </div>
                    <div className="form-group">
                      <button
                        type="submit"
                        className="text-white  w-full bg-customgreen hover:bg-hovergreen font-medium rounded-full text-sm px-5 py-2 text-center transition duration-700 ease-in-out"
                      >
                        { t('login') }
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) }
    </div>
  );
};

export default ManagementLogin;
function setStorage(response, setToken) {
  Object.keys(response).forEach((key) => {
    localStorage.setItem(key, response[key]);
    if (key === 'token') {
      setToken(response[key]);
    }
    if (key == 'id') {
      localStorage.setItem('apid', response[key]);
    }
  });
}
